/**
 * url 数据
 * 说明：1、为什么要设置cookie过期时间？ 因为依运营方需求：外媒在一天内都有效，内媒一小时有效。
 */

import cookieKit from '../lib/cookie-kit'
import urlKeyValue from '../lib/url'

// 获取参数数据
const urlCookieConfig = {
  outer_media: {
    data: urlKeyValue('outer_media'),
    expires: 60 * 60 * 24
  },
  inner_media: {
    data: urlKeyValue('outer_media') ? '' : urlKeyValue('inner_media'),
    expires: 60 * 60
  },
  adid: {
    data: urlKeyValue('adid'),
    expires: 60 * 60 * 24
  },
  cid: {
    data: urlKeyValue('cid'),
    expires: 60 * 60 * 24
  },
  appstoreid: {
    data: urlKeyValue('appstoreid'),
    expires: 60 * 60 * 24
  },
  source_id: {
    data: urlKeyValue('source') || '',
    expires: 60 * 60 * 24
  },
}

// 设置cookie
const setUrlValueCookie = () => {
  Object.keys(urlCookieConfig).forEach((item) => {
    if (urlCookieConfig[item].data) {
      cookieKit.set(`lc_${item}`, urlCookieConfig[item].data, urlCookieConfig[item].expires)
    }
  })
}

//  如果有外媒，清除内媒cookie
const mediaCookie = () => {
  urlCookieConfig.outer_media && cookieKit.clear('lc_inner_media')
}

// 初始化
export const setUrlData = () => {
  setUrlValueCookie()
  mediaCookie()
}

// 获取数据,优先取url中的数据
export const getUrlData = () => {
  return {
    outer_media: urlCookieConfig.outer_media.data || cookieKit.get('lc_outer_media'),
    inner_media: urlCookieConfig.inner_media.data || cookieKit.get('lc_inner_media'),
    adid: urlCookieConfig.adid.data || cookieKit.get('lc_adid'),
    cid: urlCookieConfig.cid.data || cookieKit.get('lc_cid'),
    appstoreid: urlCookieConfig.appstoreid.data || cookieKit.get('lc_appstoreid'),
    source_id: urlCookieConfig.source_id.data || cookieKit.get('lc_sub_client')
  }
}

export default {
  setUrlData,
  getUrlData
}
